import { Component } from '@angular/core';

@Component({
  selector: 'app-dialog-access-code-converting',
  templateUrl: './dialog-access-code-converting.component.html',
  styleUrls: ['./dialog-access-code-converting.component.scss']
})
export class DialogAccessCodeConvertingComponent {
  constructor() { }
}
